import { toast } from "react-toastify";
import config from '../../Config/config.json';
import { ChangeAllData, ChangeAnalysisData, ChangeListOperationMode, LogOut, changeHistoricCities, changeHistoricCity, changeHistoricEquipamentList, changeHistoricGraphData, changeHistoricListData, changeHistoricLoading, changeHistoricPagination, changeOnlyGraphsData, changeModal } from "../../Redux/Actions/index.js";
import { store } from "../../Redux/Store/index.js";
import { HistoricRequest } from "./requests.ts";
import i18n from "../../Config/i18n.js";

/**
 * Classe para gerenciamento da página de equipamentos
 */
export class HistoricServices {
    constructor() {
        this.Requests = new HistoricRequest();
        this.priorityItens = [
            // Geral
            'Horário',
            "Time",
            
            // Poços
            'Auto ajuste',
            'Fluoreto (ppm)',
            'Cloro livre (ppm)',
            'Cloro Livre Ponto 1 (ppm)',
            'Cloro Livre Ponto 2 (ppm)',
            'Turbidez tratada (NTU)',
            'Cor tratada (uC)',
            'Turbidez Decantada (NTU)',
            'Cor Decantada (uC)',
            'Turbidez Bruta (NTU)',
            'Cor bruta (uC)',
            'Turbidez filtrada 1 (NTU)', 'Turbidez filtrada 2 (NTU)', 'Turbidez filtrada 3 (NTU)', 'Turbidez filtrada 4 (NTU)',
            'Cor filtrada 1 (uC)', 'Cor filtrada 2 (uC)', 'Cor filtrada 3 (uC)', 'Cor filtrada 4 (uC)',
            'pH (pH)', 'pH 1 (pH)', 'pH 2 (pH)', 'pH 3 (pH)',
            'Temperatura (°C)', 'Temperatura 1 (°C)', 'Temperatura 2 (°C)', 'Temperatura 3 (°C)',
            'Vazão da bomba hipo (ml/min)',
            'Vazão da bomba ácido (ml/min)',
            'Vazão da bomba ortopolifosfato  (ml/min)',
            'Macro vazão (m³/h)', 'Macro vazão (L/s)', 'Macro diário (Litros)',
            'Nível (m)', 'Nível (%)', 'Pressão (bar)', 'Pressão (MCA)', 'Pressão 2 (bar)', 'Pressão 2 (MCA)',
            'Diferencial de pressão (bar)', 'Diferencial de pressão (MCA)',

            // Geral
            'Nível Reservatorio Elevado (%)', 
            'Nível Reservatorio Elevado (m)', 
            'Volume reservado Reservatorio Elevado (m³)',
            'Reservatorio Elevado Pressão (MCA)',
            'Volume total ocupado Reservatorio Elevado (%)',
            'Nível Reservatorio Semienterrado (%)',
            'Nível Reservatorio Semienterrado (m)',
            'Volume reservado Reservatorio Semienterrado (m³)',
            'Volume total ocupado Reservatorio Semienterrado (%)',
            'Reservatorio Semienterrado Pressão (MCA)',
            'Pressão Reservatorio Semienterrado (MCA)',

            // R8
            'Rede Areal Pressão (MCA)',
            'Rede Dunas Pressão (MCA)',
            'Rede Laranjal Pressão (MCA)',

            // R5
            'Entrada da Barragem Pressão (MCA)',
            'Saída da Duque Pressão (MCA)',
            'Saída de Aurora Pressão (MCA)',

            // Santa Barbara
            'Vazão Rede R7 (m³/h)',
            'Pressão Rede R7 (MCA)',
            'Vazão Rede R10 (m³/h)',
            'Pressão Rede R10 (MCA)',
            'Vazão Rede Centro (m³/h)',
            'Pressão Rede Centro (MCA)',
            'Vazão Rede Industrial (m³/h)',
            'Pressão Rede Industrial (MCA)',
        ];
        this.equipamentosList= [];
        this.equipamentsColors = [
            "#E69F00", // 1. Laranja
            "#0072B2", // 2. Azul profundo
            "#009E73", // 3. Verde esmeralda
            "#D55E00", // 4. Laranja avermelhado
            "#CC79A7", // 5. Rosa malva
            "#F0E442", // 6. Amarelo
            "#000000", // 7. Preto
            "#56B4E9", // 8. Azul celeste
            "#A52A2A", // 9. Marrom
            "#9400D3", // 10. Roxo
            "#00A6A6", // 11. Turquesa
            "#E7298A", // 12. Rosa vibrante
            "#66A61E", // 13. Verde oliva
            "#7570B3", // 14. Lilás azulado
            "#FF4500", // 15. Laranja avermelhado vivo
            "#191970", // 16. Azul meia-noite
            "#8B008B", // 17. Magenta escuro
            "#8B4513", // 18. Marrom sela
            "#00CED1", // 19. Turquesa
            "#DC143C", // 20. Carmesim
            "#4682B4", // 21. Azul aço
            "#FFD700", // 22. Dourado
            "#228B22", // 23. Verde floresta
            "#FF69B4", // 24. Rosa choque
            "#6A3D9A", // 25. Roxo intenso
            "#A65628", // 26. Marrom avermelhado
            "#1E90FF", // 27. Azul dodger
            "#B3DE69", // 28. Verde lima claro
            "#FB8072", // 29. Coral
            "#80B1D3", // 30. Azul pastel
            "#FDB462", // 31. Pêssego
            "#BC80BD", // 32. Lavanda
            "#B15928", // 33. Marrom terroso
            "#4DAF4A", // 34. Verde folha
            "#984EA3", // 35. Roxo ameixa
            "#377EB8", // 36. Azul médio
            "#E41A1C", // 37. Vermelho intenso
            "#A6CEE3", // 38. Azul gelo
            "#33A02C", // 39. Verde intenso
            "#FF7F00", // 40. Laranja vivo
            "#CAB2D6", // 41. Lilás claro
            "#B2DF8A", // 42. Verde pastel
            "#6B6ECF", // 43. Azul violeta
            "#17BECF", // 44. Ciano
            "#BCBD22", // 45. Amarelo oliva
            "#7F7F7F", // 46. Cinza
            "#C49C94", // 47. Rosa acastanhado
            "#393B79", // 48. Azul índigo
            "#637939", // 49. Verde musgo
            "#8C564B", // 50. Marrom médio
            "#D62728", // 51. Vermelho escuro
            "#9467BD", // 52. Violeta
            "#2CA02C", // 53. Verde folha escuro
            "#AEC7E8", // 54. Azul lavanda
            "#FFBB78", // 55. Laranja pastel
            "#C5B0D5", // 56. Roxo pastel
            "#9EDAE5", // 57. Azul piscina
            "#DBDB8D", // 58. Amarelo pastel
            "#E377C2", // 59. Rosa púrpura
            "#5254A3", // 60. Azul royal escuro

            "#B2182B", // 61. Vermelho vinho
            "#EF8A62", // 62. Salmão
            "#FDDDBC", // 63. Bege pêssego
            "#D6604D", // 64. Terracota
            "#762A83", // 65. Roxo berinjela
            "#9970AB", // 66. Malva
            "#C2A5CF", // 67. Lilás acinzentado
            "#542788", // 68. Violeta profundo
            "#2D004B", // 69. Roxo noturno
            "#2166AC", // 70. Azul oceano
            "#4393C3", // 71. Azul médio claro
            "#92C5DE", // 72. Azul névoa
            "#053061", // 73. Azul marinho profundo
            "#74ADD1", // 74. Azul suave
            "#313695", // 75. Azul ultramarino
            "#4575B4", // 76. Azul ardósia
            "#1B7837", // 77. Verde pinheiro
            "#5AAE61", // 78. Verde primavera
            "#A6D96A", // 79. Verde claro
            "#006837", // 80. Verde profundo
            "#00441B", // 81. Verde floresta escuro
            "#8CBE8C", // 82. Verde sálvia
            "#B8E186", // 83. Verde limão suave
            "#F6E8C3", // 84. Creme
            "#DFC27D", // 85. Areia dourada
            "#BF812D", // 86. Ocre
            "#8C510A", // 87. Marrom ocre
            "#543005", // 88. Marrom escuro
            "#F4A582", // 89. Salmão claro
            "#C51B7D", // 90. Fúcsia escuro
            "#DE77AE", // 91. Rosa médio
            "#F1B6DA", // 92. Rosa claro
            "#B2182B", // 93. Vermelho vinho
            "#80CDC1", // 94. Verde água
            "#35978F", // 95. Verde azulado
            "#01665E", // 96. Petróleo
            "#5E3C99", // 97. Violeta azulado
            "#3288BD", // 98. Azul oceânico
            "#66C2A5", // 99. Verde água claro
            "#E6F598", // 100. Lima pastel
        ];
    }

    // Função para buscar os equipamentos do usuário
    async getEquipamentos(){
        try {
            const equipamentosList = await this.Requests.getEquipamentosByUser();
            let List = [{id: '', nome: i18n.t("select.equipment") }];
            List.push(...equipamentosList.authorized_equipments.equipments);
            List.push(...equipamentosList.authorized_equipments.grouppings);
            this.equipamentosList = List;
            store.dispatch(changeHistoricEquipamentList(List));
            if(store.getState().HistoricReducer.city){
                this.filterEquipaments(store.getState().HistoricReducer.city);
            }
            return List;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Função para buscar os equipamentos do usuário
    async getPocos(){
        try {
            const equipamentosList = await this.Requests.getPocosByUser();
            let List = [{id: '', nome: i18n.t("select.equipment") }];
            List.push(...equipamentosList.authorized_pocos);
            this.equipamentosList = List;
            store.dispatch(changeHistoricEquipamentList(List));
            if(store.getState().HistoricReducer.city){
                this.filterEquipaments(store.getState().HistoricReducer.city);
            }
            return List;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Pega os dados gerais
    async getGeneralData(id, datainicio, datafim, page){
        try {
            let data = await this.Requests.getmappingsGeneral(id, datainicio, datafim, page);
            this.formatTable(data[2]);
            store.dispatch(changeHistoricPagination(data[1]));
            return data;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            store.dispatch(changeHistoricListData({
                data: [],
                titles: [],
            }))
            return [];
        }
    }

    // Pega os dados gerais para os gráficos
    async getGraphData(id, datainicio, datafim){
        try {
            let data = await this.Requests.getmappingsGeneralGraph(id, datainicio, datafim);
            await this.generateGraphData(data);
            // store.dispatch(changeHistoricPagination(data[1]))
            return data;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            store.dispatch(changeHistoricListData({
                data: [],
                titles: [],
            }))
            return [];
        }
    }

    // Pega os dados de analises
    async getAnalysisData(id, datainicio, datafim, page){
        try {
            let data = await this.Requests.getmappingsAnalysis(id, datainicio, datafim, page);
            let AL1 = await this.formatTableAnalysis(data[2]);
            let AL2 = await this.formatTableAnalysis(data[1]);
            let AL3 = await this.formatTableAnalysis(data[3]);
            let AL4 = await this.formatTableAnalysis(data[4]);
            let AL5 = await this.formatTableAnalysis(data[5]);
            let ph = await this.formatTableAnalysis(data[6]);

            let Cloro = this.formatDados(data[7]);
            let CorTratada = this.formatDados(data[8]);
            let Fluoreto = this.formatDados(data[9]);

            let TurbidezTratada = this.formatDados(data[10]);
            let TurbidezBruta = this.formatDados(data[11]);
            let CorBruta = this.formatDados(data[12]);

            let TurbidezFiltrada1 = this.formatDados(data[13]);
            let TurbidezFiltrada2 = this.formatDados(data[14]);
            let TurbidezFiltrada3 = this.formatDados(data[15]);
            let TurbidezFiltrada4 = this.formatDados(data[16]);
            let CorFiltrada1 = this.formatDados(data[17]);
            let CorFiltrada2 = this.formatDados(data[18]);
            let CorFiltrada3 = this.formatDados(data[19]);
            let CorFiltrada4 = this.formatDados(data[20]);
            
            let phGraph = this.formatDados(data[21]);
            let tempGraph = this.formatDados(data[22]);

            let CorTratada1 = data[23] ? this.formatDados(data[23]) : [{id: 'Cor tratada 1', data: []}];
            let TurbidezTratada1 = data[24] ? this.formatDados(data[24]) : [{id: 'Turbidez tratada 1', data: []}];
            
            let CorTratada2 = data[25] ? this.formatDados(data[25]) : [{id: 'Cor tratada 2', data: []}];
            let TurbidezTratada2 = data[26] ? this.formatDados(data[26]) : [{id: 'Turbidez tratada 2', data: []}];

            let cloro1 = data[27] ? this.formatDados(data[27]) : [{id: data[0][26], data: []}];
            let cloro2 = data[28] ? this.formatDados(data[28]) : [{id: data[0][27], data: []}];

            let sensorTable = await this.formatTableAnalysis(data[31]);
            let sensorGraph1 = this.formatDados(data[29]);
            let sensorGraph2 = this.formatDados(data[30]);

            let analysis = {
                AL1 :{
                    table: AL1,
                    graphs: [Fluoreto],
                },
                AL2 :{
                    table: AL2,
                    graphs: 
                        cloro1[0].data.length > 0 || 
                        cloro2[0].data.length > 0 ? [cloro1, cloro2] : [Cloro],
                },
                AL3 :{
                    table: AL3,
                    graphs: 
                    CorTratada1[0].data.length > 0 || CorTratada2[0].data.length > 0 || 
                    TurbidezTratada1[0].data.length > 0 || TurbidezTratada2[0].data.length > 0 ?
                        [CorTratada1, CorTratada2, TurbidezTratada1, TurbidezTratada2] :
                        [CorTratada, TurbidezTratada]
                },
                AL4 :{
                    table: AL4,
                    graphs: [CorBruta, TurbidezBruta],
                },
                AL5:{
                    table: AL5,
                    graphs: [TurbidezFiltrada1, TurbidezFiltrada2, TurbidezFiltrada3, TurbidezFiltrada4,
                        CorFiltrada1, CorFiltrada2, CorFiltrada3, CorFiltrada4],
                },
                ph:{
                    table: ph,
                    graphs: [phGraph, tempGraph],
                },
                sensor:{
                    table: sensorTable,
                    graphs: [sensorGraph1, sensorGraph2],
                }
            }
            store.dispatch(ChangeAnalysisData(analysis));
            store.dispatch(changeHistoricPagination(null));
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            store.dispatch(changeHistoricListData({
                AL1 :{table: [], graphs: [],},
                AL2 :{table: [], graphs: [],},
                AL3 :{table: [], graphs: [],},
                AL4 :{table: [], graphs: [],},
                AL5 :{table: [], graphs: [],},
                ph : {table: [], graphs: [],},
            }));
        }
    }

    // Pega os dados de analises
    async getOperationData(id, datainicio, datafim, page){
        try {
            let data = await this.Requests.getmappingsOperations(id, datainicio, datafim, page);
            this.formatTableOperation(data);
            return data;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            store.dispatch(ChangeListOperationMode([]));
            return [];
        }
    }

    // Pega os dados Detalhados
    async getAllData(id, datainicio, datafim, page){
        try {
            let data = await this.Requests.getmappingsAll(id, datainicio, datafim, page);
            this.formatTableAll(data[1]);
            store.dispatch(changeHistoricPagination(data[0]));
            return data;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            store.dispatch(changeHistoricPagination(null));
            store.dispatch(ChangeAllData({
                data: [],
                titles: [],
            }));
            return [];
        }
    }

    // Gera os dados para os gráficos
    async generateGraphData(data){
        let keys = data[0];
        let Graphdata = data.map((graphs, index) => {
            if(index !== 0 && index < data.length){
                if(graphs[0][1] === "informações" && graphs.length > 2){
                    return undefined;
                }else if(graphs.length > 2){
                    return{
                        [keys[index-1]] : this.formatDados(graphs)
                    };
                }else{
                    return undefined;
                }
            }else{
                return undefined;
            }
        })
        Graphdata = Graphdata.filter(dado => dado !== undefined);
        let priority = this.priorityItens.filter(item => 
            Graphdata.some(obj => Object.keys(obj)[0].toLowerCase().includes(item.toLowerCase()))
        );
        priority = new Map(priority.map((item, index) => [item, index]));
        Graphdata.sort((a, b) => {
            const aKey = Object.keys(a)[0];
            const bKey = Object.keys(b)[0];
            const getPriority = (key) => {
                for (let [priorityKey, priorityValue] of priority) {
                    if (key.toLowerCase().includes(priorityKey.toLowerCase())) {
                        return priorityValue;
                    }
                }
                return Infinity; 
            };
            const aPriority = getPriority(aKey);
            const bPriority = getPriority(bKey);
            if (aPriority !== bPriority) {
                return aPriority - bPriority;
            }        
            // Ordem alfabética como critério secundário
            return aKey.localeCompare(bKey);
        });
        store.dispatch(changeHistoricGraphData(Graphdata));
    }

    // Formatar os dados da tabela detalhada
    formatTableOperation(dataTable){
        if(dataTable.length > 0){
            let Operations = []
            dataTable.map((item, index) => {
                let title = item[0]
                item.shift();
                Operations[index] = {
                    title: title,
                    data: item

                }
                return item;
            });
            store.dispatch(ChangeListOperationMode(Operations));
        }else{
            store.dispatch(ChangeListOperationMode([]));
        }
    }

    // Formatar os dados da tabela detalhada
    formatTableAll(dataTable){
        if(dataTable.length > 0){
            let titles = []
            let TableData = dataTable.map(item => {
                titles = [...new Set([...titles, ...Object.keys(item)])]
                return {
                    'Values': item,
                }
            });
            let priority = this.priorityItens.filter(item => 
                titles.some(title => title.toLowerCase().includes(item.toLowerCase()))
            );
            priority = new Map(priority.map((item, index) => [item, index]));
            titles.sort((a, b) => {
                const getPriority = (title) => {
                    for (let [priorityKey, priorityValue] of priority) {
                        if (title.toLowerCase().includes(priorityKey.toLowerCase())) {
                            return priorityValue;
                        }
                    }
                    return Infinity;
                };
                const aPriority = getPriority(a);
                const bPriority = getPriority(b);
            
                return aPriority - bPriority || a.localeCompare(b);
            });
            // Caso tenha que ordenar pelo horário
            // TableData.sort((a, b) => {
            //     a.Values['Horário'] = new Date(a.Values['Horário'])
            //     b.Values['Horário'] = new Date(b.Values['Horário'])
            //     return a.Values['Horário'] - b.Values['Horário']
            // })
            TableData = {
                data: TableData,
                titles: titles,
            }
            store.dispatch(ChangeAllData(TableData));
        }else{
            store.dispatch(ChangeAllData({
                data: [],
                titles: [],
            }))
        }
    }

    // Formatar os dados da tabela de analises
    formatTableAnalysis(dataTable){
        if(dataTable.length > 1){
            let titles = [];
            let TableData = dataTable.map((item, index) => {
                if(index > 0){
                    titles = [...new Set([...titles, ...Object.keys(item[0])])]
                    return{
                        'Values': item[0],
                        'Alarms': item[1],
                    }
                }else{
                    return undefined;
                }
            });
            TableData = TableData.filter(dado => dado !== undefined);
            titles.sort();
            try {
                titles.unshift(titles.splice(titles.indexOf('pH'), 1)[0]);
                titles.push(titles.splice(titles.indexOf('Manutenção'), 1)[0]);
            } catch (error) {
                console.log(error)
            }
            titles.unshift(titles.splice(titles.indexOf('Horário'), 1)[0]);
            // Caso tenha que ordenar pelo horário
            // TableData.sort((a, b) => {
            //     a.Values['Horário'] = new Date(a.Values['Horário'])
            //     b.Values['Horário'] = new Date(b.Values['Horário'])
            //     return a.Values['Horário'] - b.Values['Horário']
            // })
            TableData = {
                data: TableData,
                titles: titles,
            }
            return TableData
        }else{
            return{
                data: [],
                titles: [],
            }
        }
    }

    // Formatar os dados da tabela geral
    formatTable(dataTable){
        if(dataTable.length > 0){
            let titles = [];
            let TableData = dataTable.map(item => {
                titles = [...new Set([...titles, ...Object.keys(item[0])])]
                return{
                    'Values': item[0],
                    'Alarms': item[1],
                }
            });
            let priority = this.priorityItens.filter(item => 
                titles.some(title => title.toLowerCase().includes(item.toLowerCase()))
            );
            priority = new Map(priority.map((item, index) => [item, index]));
            titles.sort((a, b) => {
                const getPriority = (title) => {
                    for (let [priorityKey, priorityValue] of priority) {
                        if (title.toLowerCase().includes(priorityKey.toLowerCase())) {
                            return priorityValue;
                        }
                    }
                    return Infinity;
                };
            
                const aPriority = getPriority(a);
                const bPriority = getPriority(b);
            
                return aPriority - bPriority || a.localeCompare(b);
            });
            // Caso tenha que ordenar pelo horário
            // TableData.sort((a, b) => {
            //     a.Values['Horário'] = new Date(a.Values['Horário'])
            //     b.Values['Horário'] = new Date(b.Values['Horário'])
            //     return a.Values['Horário'] - b.Values['Horário']
            // })
            TableData = {
                data: TableData,
                titles: titles,
            }
            store.dispatch(changeHistoricListData(TableData));
        }else{
            store.dispatch(changeHistoricListData({
                data: [],
                titles: [],
            }))
        }
    }

    // Formata os dados para os gráficos
    formatDados(dado){
        let dadoFormatado = [];
        let name;
        dadoFormatado = dado.map((info, index) => {
            if(index === 0 ){
                name = info[1]
                return undefined
            }else{
                if (dado.length > 5000) {
                    const anterior = dado[index - 1]?.[1];
                    const proximo = dado[index + 1]?.[1];

                    if (info[1] === anterior && info[1] === proximo) {
                        return undefined;
                    }
                }
                let value = isNaN(parseFloat(info[1])) ? info[1] : parseFloat(info[1]);
                return{
                    y: value,
                    x: new Date(info[0]),
                }
            }
        })
        dadoFormatado = dadoFormatado.filter(novodado => (novodado !== undefined && novodado.y !== undefined));
        return [{
            id: name,
            data: dadoFormatado,
            color: '#4361EE',
        }];
    }

    // Busca o arquivo na api
    async getExcel(id, datainicio, datafim, analysisMode, readingMode, methodOld, extension){
        store.dispatch(changeModal(''));
        try {
            let data1 = this.formatarDataParaYMDHMS(datainicio);
            let data2 = this.formatarDataParaYMDHMS(datafim);
            toast(i18n.t('message.historic-services.get-excel'), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            const excel = await this.Requests.getExcel(id, data1, data2, analysisMode, readingMode, methodOld, extension);
            if (excel?.data?.type === 'application/json') {
                    const text = await excel.data.text();
                    const json = JSON.parse(text);

                    toast(json.message, {
                        position: "top-center",
                        type: 'info',
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                    });
                } else {
                    let equipamentName = this.equipamentosList.find(equipamento => equipamento.id === id).nome;
                    await this.createFile(excel.data, datainicio, datafim, equipamentName, analysisMode, extension);
                }
            
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }          
    }

    // Formatar a data
    formatarDataParaYMDHMS(time) {
        let data = new Date(time);
        const year = data.getFullYear();
        const month = String(data.getMonth() + 1).padStart(2, '0');
        const day = String(data.getDate()).padStart(2, '0');
        const hours = String(data.getHours()).padStart(2, '0');
        const minutes = String(data.getMinutes()).padStart(2, '0');
        const seconds = String(data.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    // Formatar a data
    formatarDataParaDMHM(time) {
        let data = new Date(time);
        const month = String(data.getMonth() + 1).padStart(2, '0');
        const day = String(data.getDate()).padStart(2, '0');
        const hours = String(data.getHours()).padStart(2, '0');
        const minutes = String(data.getMinutes()).padStart(2, '0');
        
        return `${day}-${month} ${hours}h${minutes}m`;
    }

    // Criar o arquivo para download
    async createFile (data, data1, data2, equipamentName, analysisMode, fileFormat){
        const url = window.URL.createObjectURL(data);
        let name = this.formatarDataParaDMHM(data1) + ' até ' +  this.formatarDataParaDMHM(data2);
      
        const link = document.createElement('a');
        link.href = url;
        link.download =  analysisMode ? `${equipamentName + ' ' + name +' Análises'}.${fileFormat}` : `${equipamentName + ' ' + name}.${fileFormat}`;
        link.click();
      
        // Liberar o URL do Blob após o download
        window.URL.revokeObjectURL(url);
    }

    // Pega os dados gerais todos equipamentos
    async getAllGraphData(Ids, datainicio, datafim){
        let tempData = store.getState().HistoricReducer.onlyGraphsData;
        let colors = this.equipamentsColors;
        try {
            let FilterIds = Ids.filter(id => id !== undefined && id !== null && id !== '');
            let allGraphs = await Promise.all(FilterIds.map(id => this.getOneGraphData(id, datainicio, datafim)));
            let groupedData = [];
            let AllData = [];
            allGraphs.map((sigle, index) => {
                sigle.map(data => {
                    // Verifica se a variavel ja existe e em qual lado foi inserida
                    tempData?.map(dado => 
                        Object.values(dado).map(variaveis => variaveis.map(variavel => {
                            if(variavel.id === data[Object.keys(data)[0]][0].id){
                                data[Object.keys(data)[0]][0].active = variavel.active
                                data[Object.keys(data)[0]][0].side = variavel.side
                            }
                            return variavel;
                        }))
                    )
                    data[Object.keys(data)[0]][0].color = colors[0];
                    colors = colors.slice(1);
                    AllData.push(data[Object.keys(data)[0]][0]);
                    return data;
                })
                return sigle;
            });
            groupedData.push({'Gráfico Geral' : AllData});
            groupedData[0]["Gráfico Geral"].sort((a, b) => {
                const keyA = a.id;
                const keyB = b.id;
                return keyA.localeCompare(keyB);
            });
            store.dispatch(changeOnlyGraphsData(groupedData));
            return groupedData;
        } catch (error) {
            store.dispatch(changeOnlyGraphsData([]));
            console.log(error)
        }
    }

    // Pega os dados gerais para 1 equipamento
    async getOneGraphData(id, datainicio, datafim){
        try {
            let data = await this.Requests.getmappingsGeneralGraph(id, datainicio, datafim);
            let Graphs = await this.generateOneGraphData(data, id);
            return Graphs;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Gera os dados para os gráficos
    async generateOneGraphData(data, id){
        let keys = data[0];
        let Graphdata = data.map((graphs, index) => {
            if(index !== 0 && index < data.length){
                if(graphs[0][1] === "informações" && graphs.length > 2){
                    return undefined;
                }else if(graphs.length > 2){
                    return{
                        [keys[index-1]] : this.formatDadosId(graphs, id)
                    };
                }else{
                    return undefined;
                }
            }else{
                return undefined;
            }
        })
        Graphdata = Graphdata.filter(dado => dado !== undefined)
        let priority = this.priorityItens.filter(item => 
            Graphdata.some(obj => Object.keys(obj)[0].toLowerCase().includes(item.toLowerCase()))
        );
        priority = new Map(priority.map((item, index) => [item, index]));
        Graphdata.sort((a, b) => {
            const aKey = Object.keys(a)[0];
            const bKey = Object.keys(b)[0];
            const getPriority = (key) => {
                for (let [priorityKey, priorityValue] of priority) {
                    if (key.toLowerCase().includes(priorityKey.toLowerCase())) {
                        return priorityValue;
                    }
                }
                return Infinity; 
            };
            const aPriority = getPriority(aKey);
            const bPriority = getPriority(bKey);
            if (aPriority !== bPriority) {
                return aPriority - bPriority;
            }        
            // Ordem alfabética como critério secundário
            return aKey.localeCompare(bKey);
        });
        return Graphdata;
    }

    // Formata os dados para os gráficos
    formatDadosId(dado, id){
        let dadoFormatado = [];
        let name;
        dadoFormatado = dado.map((info, index) => {
            if(index === 0 ){
                name = info[1];
                return undefined;
            }else{
                return{
                    y: info[1],
                    x: new Date(info[0]),
                }
            }
        })
        dadoFormatado = dadoFormatado.filter(novodado => (novodado !== undefined && novodado.y !== undefined));
        let equipamentName = this.equipamentosList.find(equipamento => equipamento.id === id)?.nome;
        return [{
            id: name + ' = ' + equipamentName,
            data: dadoFormatado,
            color: '#4361EE',
        }];
    }

    // Busca as cidades
    async getCities(){
        try {
            let cities = await this.Requests.RequestCities();
            cities.authorized_cities.forEach(obj => {
                obj.id = obj.code_ibge;
                obj.nome = obj.name;
                delete obj.name;
                delete obj.code_ibge;
            })
            let list = [{id: '', nome: i18n.t("select.city")}];
            list.push(...cities.authorized_cities);
            store.dispatch(changeHistoricCities(list));
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    // Filtra os equipamentos de acordo com a cidade selecionada
    filterEquipaments(city){
        store.dispatch(changeHistoricCity(city));
        if(city){
            store.dispatch(changeHistoricLoading(true));
            let newList = this.equipamentosList.filter(equipament=> parseInt(equipament.city_code) === parseInt(city) || equipament.city_code === undefined);
            store.dispatch(changeHistoricEquipamentList(newList));
        }else{
            store.dispatch(changeHistoricEquipamentList(this.equipamentosList));
        }
    }

    async changeCity(equipamento){
        try {
            let currentCity = this.equipamentosList.find(equip => equip.id === equipamento);
            let newList = this.equipamentosList.filter(equipament => parseInt(equipament.city_code) === parseInt(currentCity.city.code_ibge) || equipament.city_code === undefined);
            if(currentCity.city){
                store.dispatch(changeHistoricEquipamentList(newList));
                store.dispatch(changeHistoricCity(currentCity.city.code_ibge));
                return currentCity.city.code_ibge;
            }else{
                store.dispatch(changeHistoricCity(''));
                return '';
            }
        } catch (error) {
            setTimeout(() => {
                this.changeCity(equipamento);
            }, 2000);
            console.log(error)
        }
        return '';
    }
}